import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

function Pharmacy() {
  const data = [
    {
      name: "Xaydarov Vosiljon Rasulovich ",
      skill: "Farmatsiya fakulteti dekani: ",
      mail: " vosiljonxaydarov@mail.ru ",
      img: "/img/vosiljonxaydarov.jpg",
      phone: "90-125-74-60"
    },
    {
      name: "Sunatova Dilfuza Abatovna ",
      skill:
        "Farmatsiya fakulteti dekanining o’quv ishlari bo’yicha o’rinbosari: ",
      mail: "mirmoh@mail.ru",
      img: "/img/dilfuzasunatova.jpg",
      phone: "99-819-12-50 "
    },
    {
      name: "Jalilov O‘tkir Mamaraximovich ",
      skill: "Farmarsevtika fanlari bo’yicha falsafa doktori ",
      mail: " jalilov_1986@list.ru",
      img: "/img/otkirjalilov.jpg",
      phone: "97-771-44-67"
    },
    {
      name: "Raxmonov Erkin Davronjonovich   ",
      skill:
        "Farmatsiya fakulteti yoshlar bilan ishlash bo’yicha dekan o’rinbosari",
      mail: "erkin_rakhmanov@mail.ru",
      img: "/img/erkinraxmonov.jpg",
      phone: " 99-830-01-03"
    },
    {
      name: "Tag’bayev Amirbek Ashirbayevich  ",
      skill:
        "Farmatsiya fakulteti yoshlar bilan ishlash bo’yicha dekan o’rinbosari",
      mail: " amirbektfi@mail.ru",
      img: "/img/amirtagbayev.jpg",
      phone: " 90-921-43-34"
    }
  ];
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="header__custom">
            <h4>Sanoat farmatsiyasi fakulteti </h4>
            {data.map((item) => (
              <div className="card__custom">
                <div className="box__custom">
                  <img src={item.img} alt />
                </div>
                <div className="box-1__custom">
                  <p> {item.name} </p>
                  <span> {item.skill} </span>
                  <br />
                  <br />
                  <hr />
                  <div className="wer__custom">
                    <div className="malinki__custom">
                      <p>E-pochta</p>
                      <span>{item.mail}</span>
                    </div>
                    <div className="malinki1__custom">
                      <p>Telefon nomer</p>
                      <span>{item.phone} </span>
                    </div>
                  </div>
                  <div className="wer__custom"></div>
                </div>
              </div>
            ))}
          </div>
          <div className="card1__custom">
            <p>
              Toshkent farmatsevtika instituti 1937 yilda Toshkent tibbiyot
              instituti negizida tashkil etilgan. O'sha paytda o'qishga qabul
              qilingan talabalar kontingenti 50 kishi edi. O‘qituvchilar tarkibi
              tibbiyot instituti kafedralari professor-o‘qituvchilari orasidan
              saylandi. 1945 yilgacha fakultet rahbariyatiga alohida dekanat
              rahbarlik qilmagan. 1945 yilda I.I.Ivlenskiy fakultet dekani etib
              tayinlandi. Keyinchalik fakultet rahbariyatiga Tolyagan Abrorov va
              Aleksandra Tatarenkolar rahbarlik qildilar.
              <br />
              Fakultetga hozirgi kunga qadar quyidagi professor-o‘qituvchilar
              rahbarlik qilganlar: 1953-1959 yy.   – N.A.Xalmatov; farmatsevtika
              fanlari doktori, professor <br />
              1959-1976 yy.    – A.Yu. Ibodov; farmatsevtika fanlari doktori,
              dotsent <br />
              1976-1978 yy.    – Ye.R.Toshmuxammedov farmatsevtika fanlari
              doktori, professor <br />
              1978-1981 yy.    – A.Yu.Ibodov farmatsevtika fanlari doktori,
              dotsent; <br />
              1981-1989 yy.    – U.A.Axmedov farmatsevtika fanlari doktori,
              professor;  <br />
              1989-1990 yy.    – A.X.Xalimov farmatsevtika fanlari nomzodi,
              dotsent; <br />
              1990-1991 yy.    – X.R.Raxmatullaev kimyo fanlari doktori,
              professor; <br />
              1991-1995 yy.    – X.K.Djalilov farmatsevtika fanlari doktori,
              professor; <br />
              1995-1999 yy.    – N.K.Olimov farmatsevtika fanlari doktori,
              professor; <br />
              1999-1999 yy.    – X.M.Komilov farmatsevtika fanlari doktori,
              professor <br />
              1999-2000 yy.    – U.A.Axmedov farmatsevtika fanlari doktori,
              professor; <br />
              2000-2001 yy.    – O.A.Shobilalov kimyo fanlari doktori,
              professor; <br />
              2001-2003 yy.    – Z.A.Yuldashev farmatsevtika fanlari doktori
              professor; <br />
              2003-2005 yy.    – A.X.Xalimov farmatsevtika fanlari nomzodi,
              dotsent; <br />
              2005-2007 yy.    – Z.Osmanov kimyo falari nomzodi, dotsent; <br />
              2007-2012 yy.    – Z.A.Yuldashev farmatsevtika fanlari doktori,
              professor <br />
              2012-2015 yy.    – A.K.Ganiev farmatsevtika fanlari nomzodi,
              professor <br />
              2015-2019 yy.    – A.A.Nurmuxammedov qishloq xo’jaligi fanlari
              nomzodi, dotsent <br />
              2019-2021 yy. – U.X.Usmanov farmatsevtika fanlari doktori <br />
              2021-h.v. – V.R.Xaydarov farmatsevtika fanlari nomzodi, professor{" "}
              <br />
              Dekanat xodimlari: Dekan - Xaydarov Vosiljon Rasulovich <br />
              Dekan muovini - Raxmonov Erkin Davlatjonovich <br />
              Dekan muovini - Jalilov O‘tkirbek Mamaraximovich <br />
              Dekan muovini - Sunatova Dilfuza Abatovna <br />
              YOshlar bilan <br />
              ishlash bo‘yicha <br />
              dekan muovini - Tag‘baev Amirbek Ashirbaevich <br />
              Uslubchi - SHomatova Sarviniso Muxammadjon qizi <br />
              Dispetcher - Qoraxodjaeva Gulchexra Saidaxmedovna <br /> Ish
              yurituvchi - Umarova Aziza To‘lqinovna <br /> Talabalar
              kontingenti: <br /> Jami talabalar soni – 2209 <br /> <br />{" "}
              Qizlar – 1035 <br /> Yigitlar – 1174 <br /> Grantlar – 330 ta{" "}
              <br /> To‘lov kontrakt – 1879
              <br />
              Fakultet quyidagi kafedralarni o‘z ichiga oladi:
              <br />
              Farmakognoziya - Farmonova Nodira Taxirovna farm.f.n., dotsent
              <br />
              Dori turlari texnologiyasi - Karieva YOkut Saidkarimovna
              farm.f.d., professor
              <br />
              Farmakologiya va klinik farmatsiya - Sultanova Ra’no Xakimovna
              farm.f.b.f.d. (PhD).
              <br />
              Noorganik, fizik va kolloid kimyo - SHaripov Avez Tuymurodovich
              farm.f.d., dotsent
              <br />
              Farmatsevtika ishini tashkil qilish - Suyunov Nizom Dovurovich
              farm.f.d., professor
              <br />
              Toksikologik kimyo kafedrasi - Usmonalieva Zumrad Uktamovna
              farm.f.n., dotsent
              <br />
              Farmatsevtik kimyo - Olimov Xayrulla Qayumovich farm.f.n., dotsent
              <br />
              Analitik kimyo - Fatxullaeva Muyassar k.f.n., dotsent
              <br />
              Quyida keltirilgan ta'lim yo'nalishlari va mutaxassisliklari uchun
              malaka talablari ishlab chiqilgan va tasdiqlangan:
              <br />
              5510500 – Farmatsiya (turlari bo’yicha)
              <br />
              5111000 – Professional ta’lim (5510500 – Farmatsiya (farmatevtika
              ishi))
              <br />
              5111000 – Kasb ta’limi (5510500 – Farmatsiya (farmatsevtika ishi))
              <br />
              5510500 – Farmatsiya (farmatsevtik tahlil)
              <br />
              5510500 – Farmatsiya (farmatsevtika ishi)
              <br />
              5510500 – Farmatsiya (klinik farmatsya)
              <br />
              Farmatsevtika fakulteti sakkiz kafedra, Axborot texnologiyalari
              kafedrasi, Markaziy ilmiy-tadqiqot laboratoriyasi, Multimedia va
              axborot resurslari markazini o‘z ichiga olgan institutning nufuzli
              bo‘linmalaridan biri hisoblanadi. Joriy o‘quv yilida fakultetda
              2100 nafardan ortiq, magistratura bo‘limida 50 nafardan ortiq
              talabalar ta’lim olmoqda. Farmatsevtika fakultetida institutning
              farmatsevtika yo‘nalishi bo‘yicha ilg‘or olimlari, professorlari,
              fan nomzodlari, dotsentlari va fan doktorlari orasidan yetakchi
              o‘qituvchilari pedagogik faoliyat olib bormoqda.
              <br />
              Fakultet professor-o‘qituvchilari tomonidan olib borilgan ilmiy
              izlanishlar natijalari doktorlik va nomzodlik dissertatsiyalarida,
              respublikamiz va xorijda chop etilayotgan qator ilmiy jurnallarda,
              xususan, “Farmatsevtika jurnali”da muntazam chop etilib
              kelinmoqda. O'qituvchilar tarkibi muntazam ravishda malakasini
              oshirib boradi. O‘qitish jarayonida ilg‘or axborot texnologiyalari
              va o‘qitishning eng so‘nggi usullaridan foydalanish talabalar
              bilim saviyasining ijobiy o‘sishida yaqqol namoyon bo‘lmoqda.
              <br />
              Farmatsevtika fakultetining tarkibiy bo‘linmasida institut
              ilmiy-tadqiqot kengashi mavjud. Ilmiy kengash ishiga fakultet
              kafedra mudirlari, davlat muassasalari rahbarlari va yetakchi
              mutaxassislar jalb etilgan.
              <br />
              Fakultet faoliyatida yuzaga keladigan va alohida e’tibor talab
              qiladigan barcha dolzarb masalalarni hal etishda Ilmiy kengashning
              ahamiyati katta. Farmatsevtika fakultetida tahsil olayotgan
              talabalar o‘z faoliyatini kimyo fanining turli yo‘nalishlarida va
              qator ilmiy laboratoriyalarda olib boradilar. Fakultet
              talabalariga ta’lim-tarbiya berish pedagogika fanining zamonaviy
              yutuqlari, ilg‘or texnologiyalar va o‘qitish uslublariga
              asoslangan.
              <br />
              Axborot-resurs markazida institutda o‘qitiladigan barcha fanlar
              bo‘yicha ma’ruza matnlari, o‘quv-uslubiy qo‘llanmalar va o‘quv
              adabiyotlari mavjud. Fakultet kafedralari zamonaviy jihozlar bilan
              ta’minlangan bo‘lib, ularda dars va ma’ruzalarni muvaffaqiyatli
              o‘tkazish uchun barcha sharoit yaratilgan. Shu bilan birga, maxsus
              dasturlar asosida iqtidorli talabalar bilan ish olib borilmoqda.
              <br />
              Talabalar, o‘quv jarayonini amaliyotga bevosita bog‘lash uchun bir
              qator farmatsevtik ishlab chiqarish korxonalari jumladan, BALZAM
              MCHJ, Novopharma plus QK, MCHJ; Nika Pharm SHK; Radiks IICHB;
              Galenika MCHJ; Remedy QK, MCHJ; Remedy Group QK, MCHJ; Samo KK;
              Nobel – Pharmsanoat CHK; Dentafill Plyus XK; Jurabek Laboratories
              QK, MCHJ; Pharmed sanoat XKlarida bo‘lishib, o‘zlarining nazariy
              bilimlarini mustahkamlash imkoniyatlariga ega bo‘lmoqdalar.
              <br />
              SHu bilan birga “SAMSUN-TOSHKENT LTD” QK, “BALZAM” MCHJ, “REMEDY
              GROUP” MCHJ, O‘zR FA Akademik S.YU.YUnusov nomidagi O‘simlik
              moddalari kimyosi instituti, “YURIYA PHARM HOLDING” MCHJ “REKA-MED
              FARM” MCHJ, “UZKIMYOFARM” OAJ O‘zR FA Mikrobiologiya instituti
              kabi bir qator mahallliy farmatsevtik ishlab chiqaruvchi
              korxonalar va ilmiy tekshirish institutlari bilan innovatsion
              korporativ hamkorlik shartnomalarini izolandi.
              <br />
              Fakultetda tashkil etilgan davrlarda asosan ikki yunalishda ilmiy
              tadqiqot ishlari olib borilgan bo‘lsa bugungi kunga kelib ular
              quyidagi besh yo‘nalishda olib borilmoqda:
              <br />
              yangi dori moddalaridan dori shakllarini (granula, tabletka,
              kapsula, surtma, shamcha, in’eksion eritma v.b.) tarkibi va
              texnologiyasini ishlab chiqish;
              <br />
              amaliyotda mavjud bo‘lgan dori vositalarining tarkibi va
              texnologiyasini takomillashtirish;
              <br />
              dorivor o‘simlik xom ashyolari asosida dori vositalarining
              (balzam, eliksir, nastoyka, suyuq va quruq ekstraktlar v.x.k.)
              tarkibi va texnologiyasini ishlab chiqish;
              <br />
              taklif qilingan dori vositalarining sifatini baxolash va biologik
              samaradorligini o‘rganish;
              <br />
              taklif qilingan dori vositalarining turg‘unligi va saqlanish
              muddatlarini belgilash;
              <br />
              Fakultetda ilmiy ish sohasi buyicha O‘zbekiston Fnlar
              akademiyasining O‘simlik moddalari kimyosi instituti, Biorganik
              kimyo instituti, "O‘zkimyofarm" OAJ, O‘zbekiston Milliy
              universiteti, Polimerlar kimyosi va fizikasi instituti, Farmatsiya
              ilmiy tekshirish instituti va bir kator boshqa institutlar bilan
              hamkorlik ishlarini olib bormokda.
              <br />
              Fakultetda muntazam ravishda iqtidorli talabalar, ilmiy to‘garak
              qatnashchilari, talabalar ilmiy jamiyati a’zolari, magistrlik
              dissertatsiyalarini bajaruvchi rezidentlar va malakaviy bitiruv
              ishini bajaruvchi talabalar, tajribali professor-o‘kituvchilar
              bilan ilmiy tadkikot ishlarini olib boradilar. Har yili institutda
              o‘tkaziladigan talabalar ilmiy anjumanida fakltet
              professor-o‘kituvchilari rahbarlik qilgan talabalar sovrinli
              o‘rinlarni egallaydilar. Bulardan eng iqtidorlilari institut va
              Fanlar akademiyasi tizimidagi ilmiy tekshirish institutlari
              aspirantlari bo‘lib, ular o‘z ilmiy ishlarini bevosita fakultet
              kafedralaridan ajralmagan holda davom ettirmokdalar. Fakultet
              kafedralarining bir qator olimlari Rossiya, Kozog‘iston,
              Belorussiya, Turkiya, Germaniya kabi davlatlarda ilmiy-safarlarda
              bo‘lishib, ilmiy anjumanlarda o‘zlarinipg ilmiy ma’ruzalari bilan
              qatnashdilar. Ilmiy izlanish natijalarini amaliyotga tatbik
              etishda bir qator yutuqlarga erishildi.
            </p>
          </div>
        </div>
        <div className="mt"></div>
      </div>
      <Footer />
    </div>
  );
}

export default Pharmacy;
